import '../styles/Boxes.css';

function LargeBox({ props }) {
    const handleClick = () => {
        window.open(props.articleLink, '_blank');
    };
    return (
        <div className="largeBox" onClick={handleClick}>
            <div className="holder">
                <div className="topicHolder">
                    {props.topics.map((topic, index) => (
                        <div className={`topic ${topic}`}>{topic}</div>
                    ))}
                </div>
                <div className="title">{props.title}</div>
                <div className="author">{props.author}</div>
            </div>
            <img src={props.imageSrc} />
        </div>
    );
}

export default LargeBox;
